import { render } from "./IconStars.vue?vue&type=template&id=2d410242&scoped=true"
const script = {}

import "./IconStars.vue?vue&type=style&index=0&id=2d410242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d410242"],['__file',"src/components/icon/IconStars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d410242"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d410242', __exports__)) {
    api.reload('2d410242', __exports__)
  }
  
  module.hot.accept("./IconStars.vue?vue&type=template&id=2d410242&scoped=true", () => {
    api.rerender('2d410242', render)
  })

}


export default __exports__